import styled from 'styled-components';

import ICoresData from '../../context/ICoresData';

interface CoresProps {
  cores: ICoresData;
}

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Fundo acinzentado e semitransparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Garante que fique acima de outros elementos */
`;

export const DialogContainer = styled.div<CoresProps>`
  background: white;
  padding: 24px;
  border-radius: 12px;
  border: 5px solid ${props => props.cores.secundaria};
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  max-width: 400px;
  width: 90%;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #000;
  }
`;

export const IconWrapper = styled.div<CoresProps>`
  font-size: 48px;
  margin-bottom: 16px;

  svg {
    color: ${props => props.cores.secundaria} !important;
  }
`;

export const MessageTitle = styled.h2<CoresProps>`
  text-align: center;
  color: ${props => props.cores.secundaria};
  font-size: 24px;
  margin-bottom: 10px;
  font-weight: bold;
`;

export const MessageText = styled.p`
  text-align: center;
  color: #333;
  font-size: 18px;
  margin: 0;
  line-height: 1.5;
`;

export const ConfirmButton = styled.button<CoresProps>`
  background: ${props => props.cores.secundaria};
  color: #fff;
  padding: 12px;
  margin-top: 12px;
  border: 1px solid ${props => props.cores.secundaria};
  border-radius: 8px;
  width: 50%;
  font-weight: bold;

  &:hover {
    background: ${props => props.cores.secundariaShade};
  }
`;
